import React, { useEffect } from "react";
import * as S from "../shared/styles";

// ----------------------------  ExitTaskModal  ----------------------------

interface ExitTaskModalProps {
  open: boolean;
  hasDraft: boolean;
  onSaveAndExit: () => void;
  onDiscardAndExit: () => void;
  onCancel: () => void;
}

const ExitTaskModal: React.FC<ExitTaskModalProps> = ({
  open,
  hasDraft,
  onSaveAndExit,
  onDiscardAndExit,
  onCancel,
}) => {
  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div style={S.modalOverlay} onClick={onCancel}>
      <div
        style={{ ...S.modalContent, maxWidth: "28rem", padding: "24px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          style={{ fontWeight: 700, fontSize: "1.125rem", color: "#111827", marginBottom: "4px" }}
        >
          Exit this task?
        </h2>
        <p
          style={{ fontSize: "0.875rem", color: "#6b7280", marginBottom: "20px", lineHeight: 1.5 }}
        >
          This task will be released back to the queue. You can save your draft to resume later, or
          discard changes.
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <button style={S.btnSecondary} onClick={onCancel}>
            Cancel
          </button>
          <button style={S.btnOutline} onClick={onDiscardAndExit}>
            Discard &amp; Exit
          </button>
          <button
            style={{ ...S.btnPrimary, opacity: hasDraft ? 1 : 0.5 }}
            disabled={!hasDraft}
            onClick={onSaveAndExit}
          >
            Save Draft &amp; Exit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExitTaskModal;
